/**
 * @generated SignedSource<<93d98308ccc6d6ed3b34236d515f6bde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditor_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_package">;
  readonly " $fragmentType": "RoomRatesTableRateEditor_package";
};
export type RoomRatesTableRateEditor_package$key = {
  readonly " $data"?: RoomRatesTableRateEditor_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditor_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditorForm_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "0d14eddbd060d2e377c9852c95d99124";

export default node;
